import { Box, Button, Card, Container, CssBaseline, Typography } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import { red } from '@mui/material/colors';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
const PaymentFailed: React.FC<{}> = () => {
  return (
    <Container sx={{ maxWidth: "lg", pt: 4 }}>
      <Card sx={{ p: 2, borderRadius: '1rem'}}>
        <CssBaseline />
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <HighlightOffIcon sx={{ fontSize: 80, color: red[500] }} />
          <Typography variant="h4" sx={{fontWeight: 600, color: red[500]}}>Payment Failed!</Typography>
          <Typography sx={{mt: 4}}>If you have any questions, please contact us at: 239-345-8001 or info@primemedteam.com</Typography>
          <Button sx={{mt: 4}} href="https://payment.primemedteam.com" variant="outlined" startIcon={<HomeIcon />}>
            Back to Payment
          </Button>
        </Box>
      </Card>
    </Container>
  );
};

export default PaymentFailed;
